import { ProductKey, QueryLogTags } from '~/queries/schema/schema-general'

export const PRODUCT_ANALYTICS_DEFAULT_QUERY_TAGS: QueryLogTags = {
    productKey: ProductKey.PRODUCT_ANALYTICS,
}
